export default __webpack_public_path__ + "static/media/lady.4cb6ba14.mp3";